import { BaSeIcon, BaSeTheme, BaSeTooltip } from '@base/react';
import React from 'react';
import { useCandidateInterview } from '../../pages/candidates/hook/useCandidateInterview';
import { BoxTag } from './data-table-styled';

function ShowToltipRegistration({ data }) {
  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  const { formatDate } = useCandidateInterview();

  const verify =
    data?.sendingExpirationEmail?.showUnfilledUnfinishedMark ?? false;

  const date = data?.sendingExpirationEmail?.sendEmailDate ?? false;

  const formatData = formatDate(new Date(date)).toString();

  const text = data?.sendingExpirationEmail?.descriptionPurpose ?? '';

  const formatMessage = `${text} ${formatData}`;

  return (
    <div>
      {verify && (
        <BoxTag
          onMouseEnter={() => setTooltipOpen(true)}
          onMouseLeave={() => setTooltipOpen(false)}
        >
          <BaSeIcon
            color={BaSeTheme.colors.feedbackInterface.sucesso26}
            description="Sólido"
            name="check-double"
            size={24}
          />
          <BaSeTooltip
            color={BaSeTheme.colors.institucionais.cinzaSebrae60}
            direction="top"
            coordinates={{ bottom: '34px' }}
            message={formatMessage}
            width={400}
            open={tooltipOpen}
          />
        </BoxTag>
      )}
    </div>
  );
}

export default ShowToltipRegistration;
